import { observable } from 'mobx';
import TopicModel from '../../../models/Maintenance/Survey/TopicModel';
import BaseStore from '../../BaseStore';

export default class TopicStore extends BaseStore {

  @observable types = [];

  constructor(transportLayer) {
    super(TopicModel, transportLayer);
  }

  fetchTypes() {
    this.transportLayer.types.fetchAll()
      .then(res => {
        this.types = res;
      })
  }

  findTypeById(id) {
    return this.types.find(item => item.id === id);
  }
  
  resolveValue(id, value) {
    let topic = this.findById(id);
    if(topic.type === 2) return +value === 1 ? 'Yes' : 'No';
    return value;
  }

};


// WEBPACK FOOTER //
// ./src/stores/Maintenance/Survey/TopicStore.js